import { render, staticRenderFns } from "./inviteSponser.vue?vue&type=template&id=b3cd7246&"
import script from "./inviteSponser.vue?vue&type=script&lang=js&"
export * from "./inviteSponser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports